/**
 * @fileoverview POST handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/creative_variants/dimensions/:dimension" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionCacheKeys } from "./constants";
import type {
  PostDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionProps,
  PostDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionResult,
} from "./types";

export const postDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimension =
  reactQueryMutationAdapter(
    postDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionCacheKeys,
    (
      props: PostDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionProps
    ): Promise<PostDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionResult> => {
      return fetch(
        `/decisioning_studio_agents/${props.appGroupId}/${props.dsaId}/creative_variants/dimensions/${props.dimension}`,
        "POST",
        {
          creative: props.creative,
          base_creative_campaign_ids: props.base_creative_campaign_ids,
        },
        undefined,
        { propagateFetchRequestError: false }
      );
    }
  );
